import { PREFIXO_HIBRIDO } from "../constants"

export const isHibrido = (codigoVenda: string = '', tipo: string = ''): boolean => {
  return codigoVenda?.toUpperCase()?.startsWith(PREFIXO_HIBRIDO) || tipo?.toLowerCase()?.includes('hibrido');
}